import React from 'react'
import Warning from '../components/Warning'
import Location from '../components/Locations'
import Caution from '../components/Caution'

import { Trans, useTranslation } from 'react-i18next'
import { useParams } from 'react-router-dom'
import { Link } from 'react-router-dom'

import '../Index.css'
import '../assets/css/materialize.css'
import '../assets/css/fontawesome.css'
import '../assets/css/fa-brands.css'
import '../assets/css/fa-regular.css'
import '../assets/css/fa-solid.css'

import whyUseImage from '../assets/images/landing/JPG/Source_3.jpg'

const Index = () => {
  const { t, i18n } = useTranslation('index')
  const { lang } = useParams()

  const currentLang = lang || i18n.resolvedLanguage // Default to detected language

  return (
    <>
      <Warning />
      <header className='home-banner'>
        <div className='content'>
          <div className='content-item-title'>
            <h1>{t('index.title')}</h1>
          </div>

          <div className='content-item'>
            <h2>{t('index.subtitle')}</h2>
          </div>

          {/* <div className="content-item-images">
            <img className="content-item-image" src="/assets/images/bitcoin.png" alt="Bitcoin" />
            <img className="content-item-image" src="/assets/images/litecoin.png" alt="Litecoin" />
          </div> */}
        </div>
      </header>

      {/* Mapa */}
      <section className='home-grey-section'>
        <Location />
      </section>

      {/* Como comprar */}
      <section className='container no-margin home-emphasis'>
        <div className="how-to-buy">
          <div className="how-to-buy-title-wrapper">
            <h2 className='text-primary-light'>
              {t('index.section2_title')}
            </h2>
          </div>

          <div className="how-to-buy-text">
            <div>
              <div>
                <p>{t('index.section2_p1')}</p>

                <p>
                  <Trans
                    t={t}
                    i18nKey='index.section2_p2'
                    components={{
                      a: (
                        <Link
                          to={
                            currentLang === 'en'
                              ? `/${currentLang}/instructions`
                              : `/${currentLang}/instrucoes`
                          }
                        >
                          {t('navbar.instructions')}
                        </Link>
                      ),
                    }}
                  />
                </p>

                <p>
                  <Trans
                    t={t}
                    i18nKey='index.section2_p3'
                    components={{
                      a: (
                        <a
                          href='/registo'
                          target='_blank'
                          rel='noreferrer'
                          aria-label='Registo'
                        />
                      ),
                    }}
                  />
                </p>
              </div>
            </div>
          </div>
{/* 
          <div className="how-to-buy-image">
            <img src={howToBuyImage} alt='' />
          </div> */}
        </div>
      </section>

      {/* Por que utilizar um terminal */}
      <section className='home-grey-section'>
      <div className="container no-margin">
        <div className="why-use">
            <div className="why-use-image">
              <div className="why-use-title-wrapper">
                <h2 className='text-primary-light'>
                  {t('index.section3_title')}
                </h2>
              </div>

              <img src={whyUseImage} alt='' />
            </div>

            <div className="why-use-text">
              <div>                
                <p className='light'>
                  <Trans
                    t={t}
                    i18nKey='index.section3_p1'
                    components={{ bold: <b /> }}
                  />
                </p>
                <p className='light'>
                  <Trans
                    t={t}
                    i18nKey='index.section3_p2'
                    components={{ bold: <b /> }}
                  />
                </p>
                <p className='light'>
                  <Trans
                    t={t}
                    i18nKey='index.section3_p3'
                    components={{ bold: <b /> }}
                  />
                </p>
              </div>
            </div>
        
          </div>
        </div>
      </section>

      {/* Precauções */}
      <Caution />
    </>
  )
}

export default Index
